import { dialCodes } from "./dialCodes";
import countries from "./countries.json";

export function getListOfCountriesWithDialCode() {
    const mapOfIsoToDial = {};

    dialCodes.forEach(dialCode => {
        mapOfIsoToDial[dialCode[0]] = dialCode[1];
    });

    return countries
        .map(country => {
            const iso2 = country.code.toLowerCase();
            return {
                iso2: iso2.toUpperCase(),
                dialCode: mapOfIsoToDial[iso2],
            };
        })
        .filter(dialCode => !!dialCode.dialCode);
}
